import * as React from 'react';
import { TextField } from './TextField';
import { Autocomplete as MuiAutocomplete, Paper, Chip } from '@mui/material';

const CustomPaper = (props) => {
    return (
        <Paper
            elevation={3}
            sx={{
                boxShadow: (theme) => theme.boxShadow,
                backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212936' : '#fff'),
                '& li': {
                    color: (theme) => theme.textColor.inputField,
                    fontSize: '16px',
                    fontWeight: 400,
                },
                backgroundImage: 'unset',
                border: (theme) => `1px solid ${theme.borderColor.inputField}`,
            }}
            {...props}
        />
    );
};

export const Autocomplete = (props) => {
    const filterOptions = (options, state) => {
        if (!options) return [];
        return options.filter(option => 
            String(option?.label || '')
                .toLowerCase()
                .includes(state.inputValue.toLowerCase())
        );
    };

    const isEqual = (option, value) => {
        if (!option || !value) return false;
        return option.value === value.value;
    };

    const {
        options = [],
        labelKey = 'label',
        label,
        width,
        placeholder,
        name,
        isSearchField,
        value,
        labelIcon,
        labelIconText,
        customStyle,
        customLabelStyles,
        disabled,
        onChange,
        disableClearable,
        blurOnSelect,
        error = false,
        helperText = '',
        inlineLabel = null,
        showTotal = false,
        onOpen,
        onClose,
        open,
        multiple = false,
        valueKey = 'value',
        renderTags
    } = props;

    const getOptionLabel = (option) => {
        if (!option) return '';
        return option[labelKey] || '';
    };

    return (
        <MuiAutocomplete
            multiple={multiple}
            disablePortal
            blurOnSelect={blurOnSelect}
            disableClearable={disableClearable}
            options={options}
            value={value || (multiple ? [] : null)}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isEqual}
            renderTags={props.renderTags || ((value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        label={getOptionLabel(option)}
                        {...getTagProps({ index })}
                        key={option[valueKey] || index}
                    />
                )))
            }
            sx={{
                width,
                '& .MuiAutocomplete-tag': {
                    backgroundColor: (theme) => theme.palette.primary.main,
                    color: '#fff',
                    '& .MuiChip-deleteIcon': {
                        color: '#fff',
                        '&:hover': {
                            color: 'rgba(255, 255, 255, 0.8)',
                        },
                    },
                },
            }}
            label={label}
            name={name}
            filterOptions={filterOptions}
            PaperComponent={CustomPaper}
            disabled={disabled}
            onChange={(e, value) => {
                if (onChange) {
                    onChange(e, value || (multiple ? [] : null));
                }
            }}
            onOpen={onOpen}
            onClose={onClose}
            open={open}
            renderOption={(props, option) => (
                <li 
                    {...props} 
                    key={option[valueKey] || option[labelKey]}
                >
                    {option[labelKey]}
                </li>
            )}
            getOptionKey={(option) => option[valueKey] || option[labelKey]}
            noOptionsText="No options"
            {...(showTotal && {
                renderOption: (props, option) => (
                    <li
                        {...props}
                        style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                    >
                        <span>{option[labelKey]}</span>
                        <span style={{ marginLeft: 'auto', fontWeight: 'bold' }}>
                            {option.total}
                        </span>
                    </li>
                ),
            })}
            renderInput={(params) => (
                <TextField
                    label={label}
                    inlineLabel={inlineLabel}
                    labelIcon={labelIcon}
                    placeholder={placeholder}
                    customStyle={customStyle}
                    labelIconText={labelIconText}
                    isSearchField={isSearchField}
                    customLabelStyles={customLabelStyles}
                    error={error}
                    helperText={helperText}
                    {...params}
                />
            )}
        />
    );
};
